import React, { useEffect, useState, } from 'react'
import { Modal } from 'react-bootstrap';
import HtmlParser from 'react-html-parser';

import 'react-tempusdominus-bootstrap';
import moment from 'moment-timezone';

import axios from 'axios';

import {
    buttonProcessGet, responseGet, globalSettings, sendMessage, styles, validateDecimals, sendMessageCloseCurrentWindowAsync, dateTimeFormatGlobalSet, languageObjGet, isUndNullEmp,
    numberSet, separatorsNumbersSet, awaitDelay,
} from '../../helpers/settings'
import { buildingModelGet } from '../../models/buildings/building';
import { elevatorModelGet } from '../../models/elevators/elevator';
import { GlobalFormats } from '../../classes/main/globalFormats';

const currentMethod = 'ElevatorAddEditDetails';

const { icons, images, labels, messages, } = globalSettings;

export default function ElevatorAddEditDetails({
    $ = {},
    auth = {},
    showModal = false,
    setShowModal = () => { },
    building = buildingModelGet({}),
    buildingTwo = buildingModelGet({}),
    elevator = elevatorModelGet({}),
    setElevator = () => { },
    elevatorGetType = () => { },
    processValues = {},
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const manufacturedId = 'manufactured';
    const [descriptionError, setDescriptionError] = useState('');
    const [brandError, setBrandError] = useState('');
    const [modelError, setModelError] = useState('');
    const [serialError, setSerialError] = useState('');
    const [manufacturedError, setManufacturedError] = useState('');
    const [heightError, setHeightError] = useState('');
    const [widthError, setWidthError] = useState('');
    const [longError, setLongError] = useState('');
    const [maxWeightError, setMaxWeightError] = useState('');
    const controls = {
        buttons: {
            save: {
                className: 'btn btn-outline-warning mx-1',
                id: 'btnModalSave',
            },
            back: {
                className: 'btn btn-outline-success',
                id: 'btnModalBack',
            },
            close: {
                className: 'close btn-danger fas fa-window-close',
                id: 'btnModalClose',
            },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        // dataTables: {
        //     buildings: {
        //         inputs: {
        //             search: {
        //                 id: `${dtBuildingsId}_filter input`,
        //                 className: '',
        //             },
        //         },
        //         selects: {
        //             entries: {
        //                 id: `${dtBuildingsId}_length select`,
        //                 className: '',
        //             },
        //         },
        //     },
        // },
        icons: {
            save: {
                id: 'iconModalSave',
                className: icons?.save,
            },
            back: {
                id: 'iconModalBack',
                className: icons?.arrowCircleLeft,
            },
        },
        inputs: {
            name: {
                id: 'inputModalName',
                className: 'form-control',
            },
            brand: {
                id: 'inputModalBrand',
                className: 'form-control',
            },
            model: {
                id: 'inputModalModel',
                className: 'form-control',
            },
            manufactured: {
                id: 'inputModalManufactured',
                className: 'form-control datetimepicker-input',
            },
            serial: {
                id: 'inputModalSerial',
                className: 'form-control',
            },
            height: {
                id: 'inputModalHeihgt',
                className: 'form-control text-right',
            },
            width: {
                id: 'inputModalWidth',
                className: 'form-control text-right',
            },
            long: {
                id: 'inputModalLong',
                className: 'form-control text-right',
            },
            maxWeight: {
                id: 'inputModalMaxWeight',
                className: 'form-control text-right',
            },
        },
        radios: {
            even: {
                id: 'radioModalEven',
                className: 'icheck-primary d-inline mx-4',
            },
            odd: {
                id: 'radioModalOdd',
                className: 'icheck-primary d-inline',
            },
            both: {
                id: 'radioModalBoth',
                className: 'icheck-primary d-inline mx-4',
            },
        },
        spinners: {
            save: {
                id: 'spModalSave',
                className: '',
            },
            back: {
                id: 'spModalBack',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion variables

    //#region methods
    const defaultValueSetAsync = async ({ isModalClose = false, subMethod = '', }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            if (isModalClose) {
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });

                response = await errosDefaultSetAsync({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                    return;
                }

                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                setShowModal(!isModalClose);
            }
            buildingTwo = building;
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const formDataSetAsync = async ({ property = '', value = '', subMethod = '', }) => {
        const currentMethod = 'formDataSetAsync';
        let response = responseGet();
        try {
            setElevator({ ...elevator, [property]: value, });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const formDataValidateAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'formDataValidateAsync';
        let response = responseGet();
        try {
            if (isUndNullEmp({ data: elevator?.description, subMethod: currentMethod, })?.result) {
                setDescriptionError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: elevator?.brand, subMethod: currentMethod, })?.result) {
                setBrandError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: elevator?.model, subMethod: currentMethod, })?.result) {
                setModelError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: elevator?.manufactured, subMethod: currentMethod, })?.result) {
                setManufacturedError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const errosDefaultSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'errosDefaultSetAsync';
        let response = responseGet();
        try {
            setDescriptionError('');
            setBrandError('');
            setModelError('');
            setManufacturedError('');
            setHeightError('');
            setWidthError('');
            setLongError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const elevatorAddPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'elevatorAddPostAsync';
        let response = responseGet();
        try {
            //#region variables
            let elevatorFound = [];
            //#region response is warning
            let responseIsWarning = responseGet();
            responseIsWarning.isWarning = true;
            responseIsWarning.msgType = 1;
            //responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
            //#endregion response is warning
            //#endregion variables

            //#region initialize
            e?.preventDefault();
            response = await errosDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await elevatorDataSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion initialize

            //#region find elevator
            //sendMessage(2, messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');
            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            if (isUndNullEmp({ data: building?.elevators, subMethod: currentMethod, })?.result) {
                building.elevators = [];
            }

            //#region by description
            elevatorFound = building?.elevators?.find(({ description }) => description === elevator?.description);
            if (!isUndNullEmp({ data: elevatorFound, subMethod: currentMethod, })?.result) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                responseIsWarning.msgText = `${messages?.thisInformationHasAlreadyBeenRecorded?.[languageObj?.id]}:<br/>`;
                responseIsWarning.msgText += `<b>${elevator?.description}</b><br/>`;
                responseIsWarning.msgText += `${messages?.pleaseEnterDifferentOne?.[languageObj?.id]}`;
                await sendMessageCloseCurrentWindowAsync({
                    msgType: responseIsWarning?.msgType,
                    msgText: !isUndNullEmp({ data: responseIsWarning?.msgHtml, subMethod: currentMethod, })?.result ? responseIsWarning?.msgHtml : responseIsWarning?.msgText,
                    closeWindow: false,
                    urlGoTo: responseIsWarning?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion by description

            //#region by serial
            elevatorFound = building.elevators.find(({ serial }) => serial === elevator?.serial && serial !== '');
            if (!isUndNullEmp({ data: elevatorFound, subMethod: currentMethod, })?.result) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                responseIsWarning.msgText = `${messages?.thisInformationHasAlreadyBeenRecorded?.[languageObj?.id]}:<br/>`;
                responseIsWarning.msgText += `<b>${elevator?.serial}</b><br/>`;
                responseIsWarning.msgText += `${messages?.pleaseEnterDifferentOne?.[languageObj?.id]}`;
                await sendMessageCloseCurrentWindowAsync({
                    msgType: responseIsWarning?.msgType,
                    msgText: !isUndNullEmp({ data: responseIsWarning?.msgHtml, subMethod: currentMethod, })?.result ? responseIsWarning?.msgHtml : responseIsWarning?.msgText,
                    closeWindow: false,
                    urlGoTo: responseIsWarning?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion by serial
            //#endregion find elevator

            //#region data save
            building?.elevators?.push(elevator);

            headerObj = {
                headers: {
                    authorization: `bearer ${processValues?.auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };
            dataObj = {
                elevators: building.elevators,
                languageId: languageObj?.id,
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlElevators}/${building.id}`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );
            response = result.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                building.elevators = building.inventories.filter(({ id }) => id !== elevator.id);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            $(`#${processValues?.dtId}`)?.DataTable()?.row?.add([
                elevator?.description,
                elevatorGetType({ data: elevator, subMethod: currentMethod, })?.result,
                elevator?.brand,
                elevator?.model,
                buttonProcessGet({
                    id: elevator?.id,
                    description: elevator?.description,
                    showDetails: true,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: true,
                    showDelete: true,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: true,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result
            ])?.draw(true);

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });

            //sendMessage(0, messages?.processesCompletedSuccessfully?.[languageObj?.id], 0, true, false, null, '');
            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: '',
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            //#endregion data save
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            building.elevators = building.inventories.filter(({ id }) => id !== elevator?.id);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const elevatorEditPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'elevatorEditPostAsync';
        let response = responseGet();
        try {
            //#region variables
            let elevatorFound = [];
            //#region response is warning
            let responseIsWarning = responseGet();
            responseIsWarning.isWarning = true;
            responseIsWarning.msgType = 1;
            //responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
            //#endregion response is warning
            //#endregion variables

            //#region initialize
            e?.preventDefault();
            response = await errosDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await elevatorDataSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion initialize

            //#region Fidn elevator
            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            if (isUndNullEmp({ data: building?.elevators, subMethod: currentMethod, })?.result) {
                building.elevators = [];
            }

            //#region by description
            elevatorFound = building?.elevators?.find(({ id, description }) => description === elevator?.description && id !== elevator?.id);
            if (!isUndNullEmp({ data: elevatorFound, subMethod: currentMethod, })?.result) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                responseIsWarning.msgText = `${messages?.thisInformationHasAlreadyBeenRecorded?.[languageObj?.id]}:<br/>`;
                responseIsWarning.msgText += `<b>${elevator?.description}</b><br/>`;
                responseIsWarning.msgText += `${messages?.pleaseEnterDifferentOne?.[languageObj?.id]}`;
                await sendMessageCloseCurrentWindowAsync({
                    msgType: responseIsWarning?.msgType,
                    msgText: !isUndNullEmp({ data: responseIsWarning?.msgHtml, subMethod: currentMethod, })?.result ? responseIsWarning?.msgHtml : responseIsWarning?.msgText,
                    closeWindow: false,
                    urlGoTo: responseIsWarning?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion by description

            //#region by serial
            elevatorFound = building.elevators.find(({ id, serial }) => serial === elevator?.serial && !isUndNullEmp({ data: serial, subMethod: currentMethod, })?.result && id !== elevator?.id);
            if (!isUndNullEmp({ data: elevatorFound, subMethod: currentMethod, })?.result) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                responseIsWarning.msgText = `${messages?.thisInformationHasAlreadyBeenRecorded?.[languageObj?.id]}:<br/>`;
                responseIsWarning.msgText += `<b>${elevator?.serial}</b><br/>`;
                responseIsWarning.msgText += `${messages?.pleaseEnterDifferentOne?.[languageObj?.id]}`;
                await sendMessageCloseCurrentWindowAsync({
                    msgType: responseIsWarning?.msgType,
                    msgText: !isUndNullEmp({ data: responseIsWarning?.msgHtml, subMethod: currentMethod, })?.result ? responseIsWarning?.msgHtml : responseIsWarning?.msgText,
                    closeWindow: false,
                    urlGoTo: responseIsWarning?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion by serial
            //#endregion find elevator

            //#region delete element from elevators
            building.elevators = building?.elevators?.filter(({ id }) => id !== elevator?.id);
            //#endregion delete element from elevators

            //#region data save
            building?.elevators?.push(elevator);

            headerObj = {
                headers: {
                    authorization: `bearer ${processValues?.auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };
            dataObj = {
                elevators: building.elevators,
                languageId: languageObj?.id,
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlElevators}/${building.id}`
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                building.elevators = building.inventories.filter(({ id }) => id !== elevator?.id);
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            $(`#${processValues?.dtId}`)?.DataTable()?.row(processValues?.rowIndex)?.data([
                elevator?.description,
                elevatorGetType({ data: elevator, subMethod: currentMethod, })?.result,
                elevator?.brand,
                elevator?.model,
                buttonProcessGet({
                    id: elevator?.id,
                    description: elevator?.description,
                    showDetails: true,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: true,
                    showDelete: true,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: true,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result
            ])?.draw(true);

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });

            sendMessage(0, messages?.processesCompletedSuccessfully?.[languageObj?.id], 0, true, false, null, '');
            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: '',
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            //#endregion data save
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            building.elevators = building.inventories.filter(({ id }) => id !== elevator?.id);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const typeElevatorSetAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'typeElevatorSetAsync';
        let response = responseGet();
        try {
            switch (e?.target?.id) {
                case controls?.radios?.even?.id:
                    elevator.even = true;
                    elevator.odd = false;
                    elevator.both = false;
                    break;
                case controls?.radios?.odd?.id:
                    elevator.even = false;
                    elevator.odd = true;
                    elevator.both = false;
                    break;
                default:
                    elevator.even = false;
                    elevator.odd = false;
                    elevator.both = true;
                    break;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            //console?.log(response);
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const elevatorDataSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'elevatorDataSetAsync';
        let response = responseGet();
        try {
            //const manufactured = $(`#${manufacturedId}`)?.datetimepicker('date')?._i;
            const manufactured = $(`#${manufacturedId}`)?.datetimepicker('date')?._d;
            elevator.manufactured = !isUndNullEmp({ data: manufactured, subMethod: currentMethod, })?.result ? manufactured?.toString() : '';
            elevator.height = numberSet({ number: elevator?.height, type: 'd', languageId: languageObj?.id, subMethod: currentMethod })?.result; //numberSet(elevator.height, 'd');
            elevator.width = numberSet({ number: elevator?.width, type: 'd', languageId: languageObj?.id, subMethod: currentMethod })?.result; //numberSet(elevator.width, 'd');
            elevator.long = numberSet({ number: elevator?.long, type: 'd', languageId: languageObj?.id, subMethod: currentMethod })?.result; //numberSet(elevator.long, 'd');
            elevator.maxWeight = numberSet({ number: elevator?.maxWeight, type: 'd', languageId: languageObj?.id, subMethod: currentMethod })?.result; //numberSet(elevator.maxWeight, 'd');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dateInControlSet = ({ date = new Date(), manufactured = undefined, subMethod = '', }) => {
        let response = responseGet();
        try {
            //#region variables
            //#region old code
            //let dateTimeObj?.date = '';
            //const dateTimeObj?.format = globalSettings?.react?.tempusDominus?.format?.date?.dmy;
            //const dateTimeObj?.formatTwo = globalSettings?.react?.tempusDominus?.format?.date?.DDMMYYYY;
            //#endregion old code
            const dateTimeObj = {
                date: '',
                format: languageObj?.format?.date?.f1,
                //formatTwo: `${languageObj?.format?.date?.f11} ${languageObj?.format?.time?.picker?.hhmm}`,
                formatTwo: languageObj?.format?.date?.f11,
            };
            //#endregion variables

            //#region Method
            if (!isUndNullEmp({ data: manufactured, subMethod: currentMethod, })?.result) {
                dateTimeObj.date = dateTimeFormatGlobalSet({
                    date: manufactured,
                    type: dateTimeObj?.format,
                    format: 0,
                    addTime: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            } else if (!isUndNullEmp({ data: date, subMethod: currentMethod, })?.result) {
                dateTimeObj.date = dateTimeFormatGlobalSet({
                    date: date,
                    type: dateTimeObj?.format,
                    format: 0,
                    addTime: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            }

            $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
                icons: globalSettings?.react?.tempusDominus?.icons,
                buttons: globalSettings?.react?.tempusDominus?.buttons,
                tooltips: globalSettings?.react?.tempusDominus?.tooltips({ languageId: languageObj?.id }),
                locale: languageObj?.id,
            });

            $(`#${manufacturedId}`)?.datetimepicker({
                date: moment(dateTimeObj?.date, `${dateTimeObj?.formatTwo}`),
                default: false,
                format: `${dateTimeObj?.formatTwo}`,
            });
            //#endregion Method
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            response = dateInControlSet({
                date: new Date(),
                manufactured: elevator?.manufactured || undefined,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
        } catch (ex) {
            //controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.removeClass();

                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.removeClass();

                    $(`#${controls?.buttons?.back?.id}`)?.removeClass();

                    $(`#${controls?.icons?.save?.id}`)?.addClass(controls?.icons?.save.className);
                    $(`#${controls?.buttons?.save?.id}`)?.addClass(controls?.buttons?.save?.className);
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(controls?.spinners?.save?.className);

                    $(`#${controls?.icons?.back?.id}`)?.addClass(controls?.icons?.back.className);
                    $(`#${controls?.buttons?.back?.id}`)?.addClass(controls?.buttons?.back?.className);
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(controls?.spinners?.back?.className);

                    $(`#${controls?.buttons?.close?.id}`)?.addClass(controls?.buttons?.close?.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.inputs?.name?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.brand?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.model?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.manufactured?.id}`)?.attr('disabled', (processType !== 0));
            $(`#${controls?.inputs?.serial?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.height?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.width?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.long?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.maxWeight?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.radios?.even?.id}`)?.attr('disabled', (processType !== 0));
            $(`#${controls?.radios?.odd?.id}`)?.attr('disabled', (processType !== 0));
            $(`#${controls?.radios?.both?.id}`)?.attr('disabled', (processType !== 0));
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region old code
            // $(`#${controls?.dataTables?.buildings?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            // $(`#${controls?.dataTables?.buildings?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            //#endregion old code

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'onLoad - form', });
    }, []); //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        // <Modal backdrop='static' show={showModal} onHide={() => setShowModal(false)}>
        <Modal backdrop='static' show={showModal} onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'modal - from', })}>
            <Modal.Header>
                <Modal.Title>
                    <img alt={labels?.elevator?.[languageObj?.id]}
                        src={images?.elevatorsLogo}
                        style={styles?.cardHeaderLogo}></img> - {labels?.elevator?.[languageObj?.id]} ({processValues?.type === 0 ?
                            labels?.add?.[languageObj?.id]?.toLowerCase() :
                            processValues?.type === 1 ?
                                labels?.edit?.[languageObj?.id]?.toLowerCase() :
                                labels?.detail?.[languageObj?.id]?.toLowerCase()})
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    data-dismiss='modal'
                    aria-label='Close'
                    type='button'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'modal - btnHeadClose', })}>
                </button>
            </Modal.Header>
            <form onSubmit={(e) => processValues?.type === 0 ?
                elevatorAddPostAsync({ e: e, subMethod: 'modal - form' }) : processValues?.type === 1 ?
                    elevatorEditPostAsync({ e: e, subMethod: 'modal - form', }) : e?.preventDefault()}>
                <Modal.Body>
                    {/* <div className='card card-primary card-outline shadow' > */}
                    {/* <form onSubmit={(e) => processValues?.type === 0 ? elevatorAddPostAsync(e) : processValues?.type === 1 ? elevatorEditPostAsync(e) : e?.preventDefault()}> */}

                    {/* Header */}
                    {/* <div className='card-header'>
                            <h6 className='card-title'><img alt={labels?.elevator?.[languageObj?.id]} src={images?.elevatorsLogo} style={styles?.cardHeaderLogo}></img> - {labels?.elevator?.[languageObj?.id]}</h6>
                        </div> */}

                    {/* Body */}
                    {/* <div className='card-body'> */}
                    {!isUndNullEmp({ data: elevator, subMethod: 'modal - body' })?.result ?
                        <div>{processValues?.type !== 2 ?
                            <div>
                                <div className='form-group'>
                                    <div className='input-group mb-3'>
                                        <input id={controls?.inputs?.name?.id}
                                            //autoFocus
                                            className={controls?.inputs?.name?.className}
                                            placeholder={labels?.name?.[languageObj?.id]}
                                            onChange={(e) => formDataSetAsync({ property: 'description', value: e?.target?.value, subMethod: 'input - desceiprion', })}
                                            onFocus={() => setDescriptionError('')}
                                            value={elevator?.description || ''}
                                            tooltip='tooltip'
                                            title={labels?.name?.[languageObj?.id]} />
                                        <div className='input-group-append'>
                                            <div className='input-group-text'>
                                                <span className={icons?.spellCheck} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(descriptionError)}</div>
                                </div>

                                <div className='form-group'>
                                    <div className='text-center'>
                                        <div className={controls?.radios?.even?.className}>
                                            <input type='radio'
                                                id={controls?.radios?.even?.id}
                                                name='r1'
                                                defaultChecked={elevator.even}
                                                onChange={(e) => typeElevatorSetAsync({ e: e, subMethod: 'radio - event' })} />
                                            <label htmlFor={controls?.radios?.even?.id}>{labels?.even?.[languageObj?.id]}</label>
                                        </div>
                                        <div className={controls?.radios?.odd?.className}>
                                            <input type='radio'
                                                id={controls?.radios?.odd?.id}
                                                name='r1'
                                                defaultChecked={elevator.odd}
                                                onChange={(e) => typeElevatorSetAsync({ e: e, subMethod: 'radio - odd' })} />
                                            <label htmlFor={controls?.radios?.odd?.id}>{labels?.odd?.[languageObj?.id]}</label>
                                        </div>
                                        <div className={controls?.radios?.both?.className}>
                                            <input type='radio'
                                                id={controls?.radios?.both?.id}
                                                name='r1'
                                                defaultChecked={elevator.both}
                                                onChange={(e) => typeElevatorSetAsync({ e: e, subMethod: 'radio - both' })} />
                                            <label htmlFor={controls?.radios?.both?.id}>{labels?.both?.[languageObj?.id]}</label>
                                        </div>
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-md-6'>
                                        <div className='form-group'>
                                            <div className='input-group mb-3'>
                                                <input id={controls?.inputs?.brand?.id}
                                                    className={controls?.inputs?.brand?.className}
                                                    placeholder={labels?.brand?.[languageObj?.id]}
                                                    onChange={(e) => formDataSetAsync({ property: 'brand', value: e?.target?.value, subMethod: 'input - brand', })}
                                                    onFocus={() => setBrandError('')}
                                                    value={elevator?.brand || ''}
                                                    tooltip='tooltip'
                                                    title={labels?.brand?.[languageObj?.id]} />
                                                <div className='input-group-append'>
                                                    <div className='input-group-text'>
                                                        <span className={icons?.fasFa?.copyright} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(brandError)}</div>
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='form-group'>
                                            <div className='input-group mb-3'>
                                                <input id={controls?.inputs?.model?.id}
                                                    className={controls?.inputs?.model?.className}
                                                    placeholder={labels?.model?.[languageObj?.id]}
                                                    onChange={(e) => formDataSetAsync({ property: 'model', value: e?.target?.value, subMethod: 'input - model', })}
                                                    onFocus={() => setModelError('')}
                                                    value={elevator?.model || ''}
                                                    tooltip='tooltip'
                                                    title={labels?.model?.[languageObj?.id]} />
                                                <div className='input-group-append'>
                                                    <div className='input-group-text'>
                                                        <span className={icons?.fasFa?.ad} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(modelError)}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-md-6'>
                                        <div className='form-group'>
                                            <div className='input-group mb-3'>
                                                <div className='input-group date'
                                                    id={manufacturedId}
                                                    data-target-input='nearest'>
                                                    <input id={controls?.inputs?.manufactured?.id}
                                                        className={controls?.inputs?.manufactured?.className}
                                                        //className='form-control datetimepicker-input'
                                                        data-target={`#${manufacturedId}`}
                                                        data-toggle='datetimepicker'
                                                        onFocus={() => setManufacturedError('')}
                                                        placeholder={labels?.manufactured?.[languageObj?.id]}
                                                        //tabIndex={-1}
                                                        tooltip='tooltip'
                                                        title={labels?.manufactured?.[languageObj?.id]}
                                                        type='text' />
                                                    <div className='input-group-append'
                                                        data-target={`#${manufacturedId}`}
                                                        data-toggle='datetimepicker'>
                                                        <div className='input-group-text'><i className={icons?.calendarAlt}></i></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(manufacturedError)}</div>
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='form-group'>
                                            <div className='input-group mb-3'>
                                                <input id={controls?.inputs?.serial?.id}
                                                    className={controls?.inputs?.serial?.className}
                                                    placeholder={labels?.serial?.[languageObj?.id]}
                                                    onChange={(e) => formDataSetAsync({ property: 'serial', value: e?.target?.value, subMethod: 'input - serial', })}
                                                    onFocus={() => setSerialError('')}
                                                    value={elevator?.serial || ''}
                                                    tooltip='tooltip'
                                                    title={labels?.serial?.[languageObj?.id]} />
                                                <div className='input-group-append'>
                                                    <div className='input-group-text'>
                                                        <span className={icons?.fasFa?.barCode} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(serialError)}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-md-6'>
                                        <div className='form-group'>
                                            <div className='input-group mb-3'>
                                                <input id={controls?.inputs?.height?.id}
                                                    className={controls?.inputs?.height?.className}
                                                    //className='form-control text-right'
                                                    placeholder={labels?.height?.[languageObj?.id]}
                                                    onChange={(e) => formDataSetAsync(
                                                        {
                                                            property: 'height',
                                                            //value: parseFloat(validateDecimals({ e: e, languageId: languageObj?.id, subMethod: 'input - height', })) ? '0.00' : validateDecimals({ e: e, languageId: languageObj?.id, subMethod: 'input - height', }),
                                                            value: isNaN(parseFloat(validateDecimals({ e: e, languageId: languageObj?.id, subMethod: 'input - height', }))) ? numberSet({ number: '0.00', type: 'd', languageId: languageObj?.id, subMethod: 'input - height', })?.result : validateDecimals({ e: e, languageId: languageObj?.id, subMethod: 'input - height', }),
                                                        }
                                                    )}
                                                    onFocus={() => setHeightError('')}
                                                    value={elevator?.height || '0.00'}
                                                    tooltip='tooltip'
                                                    title={labels?.height?.[languageObj?.id]} />
                                                <div className='input-group-append'>
                                                    <div className='input-group-text'>
                                                        <span className={icons?.fasFa?.arrowsAltV} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(heightError)}</div>
                                        </div>
                                    </div>

                                    <div className='col-md-6'>
                                        <div className='form-group'>
                                            <div className='input-group mb-3'>
                                                <input id={controls?.inputs?.width?.id}
                                                    className={controls?.inputs?.width?.className}
                                                    //className='form-control text-right'
                                                    placeholder={labels?.width?.[languageObj?.id]}
                                                    //onChange={(e) => formDataSetAsync('width', isNaN(parseFloat(validateDecimals(e))) ? '0.00' : validateDecimals(e))}
                                                    onChange={(e) => formDataSetAsync(
                                                        {
                                                            property: 'width',
                                                            value: isNaN(parseFloat(validateDecimals({ e: e, languageId: languageObj?.id, subMethod: 'input - width', }))) ? numberSet({ number: '0.00', type: 'd', languageId: languageObj?.id, subMethod: 'input - width', })?.result : validateDecimals({ e: e, languageId: languageObj?.id, subMethod: 'input - width', }),
                                                        }
                                                    )}
                                                    onFocus={() => setWidthError('')}
                                                    value={elevator?.width || '0.00'}
                                                    tooltip='tooltip'
                                                    title={labels?.width?.[languageObj?.id]} />
                                                <div className='input-group-append'>
                                                    <div className='input-group-text'>
                                                        <span className={icons?.fasFa?.arrowsAltH} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(widthError)}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-md-6'>
                                        <div className='form-group'>
                                            <div className='input-group mb-3'>
                                                <input id={controls?.inputs?.long?.id}
                                                    className={controls?.inputs?.long?.className}
                                                    //className='form-control text-right'
                                                    placeholder={labels?.long?.[languageObj?.id]}
                                                    //onChange={(e) => formDataSetAsync('long', isNaN(parseFloat(validateDecimals(e))) ? '0.00' : validateDecimals(e))}
                                                    onChange={(e) => formDataSetAsync(
                                                        {
                                                            property: 'long',
                                                            value: isNaN(parseFloat(validateDecimals({ e: e, languageId: languageObj?.id, subMethod: 'input - long', }))) ? numberSet({ number: '0.00', type: 'd', languageId: languageObj?.id, subMethod: 'input - long', })?.result : validateDecimals({ e: e, languageId: languageObj?.id, subMethod: 'input - long', }),
                                                        }
                                                    )}
                                                    onFocus={() => setLongError('')}
                                                    value={elevator?.long || '0.00'}
                                                    tooltip='tooltip'
                                                    title={labels?.long?.[languageObj?.id]} />
                                                <div className='input-group-append'>
                                                    <div className='input-group-text'>
                                                        <span className={icons?.fasFa?.expandArrowsAlt} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(longError)}</div>
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='form-group'>
                                            <div className='input-group mb-3'>
                                                <input id={controls?.inputs?.maxWeight?.id}
                                                    className={controls?.inputs?.maxWeight?.className}
                                                    //className='form-control text-right'
                                                    placeholder={labels?.maxWeight?.[languageObj?.id]}
                                                    //onChange={(e) => formDataSetAsync('maxWeight', isNaN(parseFloat(validateDecimals(e))) ? '0.00' : validateDecimals(e))}
                                                    onChange={(e) => formDataSetAsync(
                                                        {
                                                            property: 'maxWeight',
                                                            value: isNaN(parseFloat(validateDecimals({ e: e, languageId: languageObj?.id, subMethod: 'input - maxWeight', }))) ? numberSet({ number: '0.00', type: 'd', languageId: languageObj?.id, subMethod: 'input - maxWeight', })?.result : validateDecimals({ e: e, languageId: languageObj?.id, subMethod: 'input - maxWeight', }),
                                                        }
                                                    )}
                                                    onFocus={() => setMaxWeightError('')}
                                                    value={elevator?.maxWeight || '0.00'}
                                                    tooltip='tooltip'
                                                    title={labels?.maxWeight?.[languageObj?.id]} />
                                                <div className='input-group-append'>
                                                    <div className='input-group-text'>
                                                        <span className={icons?.fasFa?.weight} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(maxWeightError)}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className='text-muted'>
                                <div className='row'>
                                    <div className='col-md-4'>
                                        <b>{labels?.description?.[languageObj?.id]}:</b>
                                    </div>
                                    <div className='col-md-8'>
                                        {!isUndNullEmp({ data: elevator?.description, subMethod: 'label - name', })?.result ? elevator?.description : ''}
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-md-4'>
                                        <b>{labels?.type?.[languageObj?.id]}:</b>
                                    </div>
                                    <div className='col-md-8'>
                                        {!isUndNullEmp({ data: elevator?.even, subMethod: 'label - even', })?.result && elevator?.even ?
                                            <div className='icheck-primary d-inline'>
                                                <input type='radio'
                                                    id={controls?.radios?.even?.id}
                                                    name='r1'
                                                    defaultChecked={elevator?.even}
                                                    readOnly />
                                                <label htmlFor={controls?.radios?.even?.id}>{labels?.even?.[languageObj?.id]}</label>
                                            </div>
                                            :
                                            <></>
                                        }
                                        {!isUndNullEmp({ data: elevator?.odd, subMethod: 'label - odd', })?.result && elevator?.odd ?
                                            <div className='icheck-primary d-inline'>
                                                <input type='radio'
                                                    id={controls?.radios?.odd?.id}
                                                    name='r1'
                                                    defaultChecked={elevator?.odd}
                                                    readOnly />
                                                <label htmlFor='radioOdd'>{labels?.odd?.[languageObj?.id]}</label>
                                            </div>
                                            :
                                            <></>
                                        }
                                        {!isUndNullEmp({ data: elevator?.both, subMethod: 'label - both', })?.result && elevator?.both ?
                                            <div className='icheck-primary d-inline'>
                                                <input type='radio'
                                                    id={controls?.radios?.both?.id}
                                                    name='r1'
                                                    defaultChecked={elevator?.both}
                                                    readOnly />
                                                <label htmlFor='radioBoth'>{labels?.both?.[languageObj?.id]}</label>
                                            </div>
                                            :
                                            <></>
                                        }
                                        {/* <div className='icheck-primary d-inline'>
                                                    <input type='radio' defaultChecked={
                                                        (!isUndefined(elevator.even) && !isNull(elevator.even) && elevator.even) ||
                                                            (!isUndefined(elevator.odd) && !isNull(elevator.odd) && elevator.odd) ||
                                                            (!isUndefined(elevator.both) && !isNull(elevator.both) && elevator.both) ? true : false}
                                                        readOnly />
                                                    <label htmlFor='radioBoth'>{
                                                        (!isUndefined(elevator.even) && !isNull(elevator.even) && elevator.even) ?
                                                            labels?.even?.[languageObj?.id] :
                                                            (!isUndefined(elevator.odd) && !isNull(elevator.odd) && elevator.odd) ?
                                                                labels?.odd?.[languageObj?.id] :
                                                                (!isUndefined(elevator.both) && !isNull(elevator.both) && elevator.both) ?
                                                                    labels?.odd?.[languageObj?.id] :
                                                                    ''}
                                                    </label>
                                                </div> */}
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-md-4'>
                                        <b>{labels?.brand?.[languageObj?.id]}:</b>
                                    </div>
                                    <div className='col-md-8'>
                                        {!isUndNullEmp({ data: elevator?.brand, subMethod: 'label - brand' })?.result ? elevator?.brand : ''}
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-md-4'>
                                        <b>{labels?.model?.[languageObj?.id]}:</b>
                                    </div>
                                    <div className='col-md-8'>
                                        {!isUndNullEmp({ data: elevator?.model, subMethod: 'label - model' })?.result ? elevator?.model : ''}
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-md-4'>
                                        <b>{labels?.manufactured?.[languageObj?.id]}:</b>
                                    </div>
                                    <div className='col-md-8'>
                                        {dateTimeFormatGlobalSet({
                                            date: !isUndNullEmp({ data: elevator?.manufactured, subMethod: 'label - manufactuted', })?.result ? elevator?.manufactured : new Date(),
                                            type: languageObj?.format?.date?.f1,
                                            format: 0,
                                            addTime: false,
                                            languageId: languageObj?.id,
                                            subMethod: 'label - manufactured'
                                        })?.result}
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-md-4'>
                                        <b>{labels?.serial?.[languageObj?.id]}:</b>
                                    </div>
                                    <div className='col-md-8'>
                                        {!isUndNullEmp({ data: elevator?.serial, subMethod: 'label - serial' })?.result ? elevator?.serial : ''}
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-md-4'>
                                        <b>{labels?.height?.[languageObj?.id]}:</b>
                                    </div>
                                    <div className='col-md-8'>
                                        {separatorsNumbersSet({
                                            number: !isUndNullEmp({ data: elevator?.height, subMethod: 'label - height' })?.result ? elevator?.height : '0.00',
                                            withDecimals: true,
                                            consoleLogErrorShow: true,
                                            subMethod: 'label - height',
                                        })?.result}
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-md-4'>
                                        <b>{labels?.width?.[languageObj?.id]}:</b>
                                    </div>
                                    <div className='col-md-8'>
                                        {separatorsNumbersSet({
                                            number: !isUndNullEmp({ data: elevator?.width, subMethod: 'label - height' })?.result ? elevator?.width : '0.00',
                                            withDecimals: true,
                                            consoleLogErrorShow: true,
                                            subMethod: 'label - width',
                                        })?.result}
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-md-4'>
                                        <b>{labels?.long?.[languageObj?.id]}:</b>
                                    </div>
                                    <div className='col-md-8'>
                                        {separatorsNumbersSet({
                                            number: !isUndNullEmp({ data: elevator?.long, subMethod: 'label - long' })?.result ? elevator?.long : '0.00',
                                            withDecimals: true,
                                            consoleLogErrorShow: true,
                                            subMethod: 'label - long',
                                        })?.result}
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-md-4'>
                                        <b>{labels?.maxWeight?.[languageObj?.id]}:</b>
                                    </div>
                                    <div className='col-md-8'>
                                        {separatorsNumbersSet({
                                            number: !isUndNullEmp({ data: elevator?.maxWeight, subMethod: 'label - height' })?.result ? elevator?.maxWeight : '0.00',
                                            withDecimals: true,
                                            consoleLogErrorShow: true,
                                            subMethod: 'label - maxWeight',
                                        })?.result}
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-md-12'>
                                        <hr />
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-md-4'>
                                        <b>{labels?.date?.[languageObj?.id]}:</b>
                                    </div>
                                    <div className='col-md-8'>
                                        {dateTimeFormatGlobalSet({
                                            date: !isUndNullEmp({ data: elevator?.created, subMethod: 'label - created', })?.result ? elevator?.created : new Date(),
                                            type: languageObj?.format?.date?.f1,
                                            format: languageObj?.format?.time?.type,
                                            addTime: false,
                                            languageId: languageObj?.id,
                                            subMethod: 'label - created'
                                        })?.result}
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-md-4'>
                                        <b>{labels?.user?.[languageObj?.id]}:</b>
                                    </div>
                                    <div className='col-md-8'>
                                        {!isUndNullEmp({ data: processValues?.user, subMethod: 'label - user' })?.result ? `${processValues?.user?.firstName || ''}, ${processValues?.user?.lastName || ''}` : ''}
                                    </div>
                                </div>
                            </div>
                        }
                        </div>
                        : <></>
                    }
                    {/* </div> */}

                    {/* Footer */}
                    {/* <div className='card-footer'>
                            <div className='form-group text-right'>
                                {processValues?.type !== 2 ?
                                    <button className='btn btn-outline-warning mx-1'
                                        tooltip='tooltip'
                                        title={processValues?.type === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                                        type='submit'>
                                        <i className={icons?.save}></i>
                                    </button>
                                    :
                                    <></>
                                }
                                <button className='btn btn-outline-success'
                                    tooltip='tooltip'
                                    title={labels?.close?.[languageObj?.id]}
                                    type='reset'
                                    onClick={() => defaultValueSetAsync({isModalClose: true, subMethod: 'modal - btnFooterClose', })}>
                                    <i className={icons?.arrowCircleLeft}></i>
                                </button>
                            </div>
                        </div> */}

                    {/* </form> */}
                    {/* </div> */}
                </Modal.Body>

                <Modal.Footer>
                    <div className='form-group text-right'>
                        {processValues?.type !== 2 ?
                            <button id={controls?.buttons?.save?.id}
                                className={controls?.buttons?.save?.className}
                                tooltip='tooltip'
                                title={processValues?.type === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                                type='submit'>
                                {/* <i className={icons?.save}></i> */}
                                <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                            </button>
                            :
                            <></>
                        }
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.className}
                            tooltip='tooltip'
                            title={labels?.close?.[languageObj?.id]}
                            type='reset'
                            onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'modal - btnFooterClose', })}>
                            {/* <i className={icons?.arrowCircleLeft}></i> */}
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}